// Footer.jsx
import React from 'react';
import SocialLinks from './SocialLinks';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer bg-dark text-white pt-5 pb-4">
      <div className="container">
        {/* CONTACTAR Section */}
        <div className="row mb-4">
          <div className="col-12">
            <h5 className="mb-3">CONTACTAR</h5>
            <SocialLinks />
          </div>
        </div>

        {/* ENTIDADES COLABORADORAS Section */}
        <div className="row">
          <div className="col-12">
            <h5 className="mb-4 widget-heading">ENTIDADES COLABORADORAS</h5>
          </div>
          {/* Principal Partners */}
          <div className="col-md-3 mb-2 ">
            <h6 className="widget-info-text mb-0">Principal Partners</h6>
            <ul className="list-unstyled">
              <li>
                <a href="https://www.facebook.com/modunovacasasdehormigon/about" target="_blank" rel="noreferrer noopener" className="widget-link">
                  Modunova Casas Prefabricadas de Hormigón
                </a>
              </li>
              <li>
                <a href="https://colegionaturopatas.es" target="_blank" rel="noreferrer noopener" className="widget-link">
                  FENACO
                </a>
              </li>
              <li>
                <a href="https://abogadosgarcdelaregal.com" target="_blank" rel="noreferrer noopener" className="widget-link">
                  Abogados Garcdela Regal
                </a>
              </li>
            </ul>
          </div>
          {/* Educational Partners */}
          <div className="col-md-3 mb-2">
            <h6 className="widget-info-text mb-0">Educational Partners</h6>
            <ul className="list-unstyled">
              <li>
                <a href="http://www.iesae.com/" target="_blank" rel="noreferrer noopener" className="widget-link">
                  I.E.S. Albert Einstein
                </a>
              </li>
              <li>
                <a href="http://www.losviveros.es/" target="_blank" rel="noreferrer noopener" className="widget-link">
                  I.E.S. Los Viveros
                </a>
              </li>
              <li>
                <a href="https://medac.es/" target="_blank" rel="noreferrer noopener" className="widget-link">
                  Instituto de Oficial de Formación MEDAC
                </a>
              </li>
              <li>
                <a href="https://www.campustraining.es/" target="_blank" rel="noreferrer noopener" className="widget-link">
                  Campus Training
                </a>
              </li>
              <li>
                <a href="https://www.ilerna.es/" target="_blank" rel="noreferrer noopener" className="widget-link">
                  Ilerna
                </a>
              </li>
              <li>
                <a href="https://www.ceac.es/" target="_blank" rel="noreferrer noopener" className="widget-link">
                  CEDAC
                </a>
              </li>
              <li>
                <a href="https://www.cesurformacion.com/" target="_blank" rel="noreferrer noopener" className="widget-link">
                  CESUR
                </a>
              </li>
            </ul>
          </div>
          {/* Media Partners */}
          <div className="col-md-2 mb-2">
            <h6 className="widget-info-text mb-0">Media Partners</h6>
            <ul className="list-unstyled">
              <li>
                <a href="https://ondaguillena.org/" target="_blank" rel="noreferrer noopener" className="widget-link">
                  Onda Guillena radio
                </a>
              </li>
              <li>
                <a href="/" target="_blank" rel="noreferrer noopener" className="widget-link">
                  El vuelo del pingüino
                </a>
              </li>
            </ul>
          </div>
          {/* Clubs Partners */}
          <div className="col-md-3 mb-2">
            <h6 className="widget-info-text mb-0">Clubs Partners</h6>
            <ul className="list-unstyled">
              <li>
                <a href="/club-corredores" className="widget-link">
                  Club de corredores EquipoMAG.</a>
              </li>
              <li>
                <a href="https://www.facebook.com/alcaladelrio.cf" target="_blank" rel="noreferrer noopener" className="widget-link">
                  Alcalá del Río C.F.</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h5 className="mb-4 widget-heading">Contáctanos</h5>
          </div>
          {/* Principal Partners */}
          <div className="col-md-3 mb-2 ">
            <h6 className="widget-info-text mb-0">Trabaja con nosotros</h6>
            <ul className="list-unstyled">
              <li>
                <a href="https://www.linkedin.com/company/equipomag/jobs/?viewAsMember=true" target="_blank" rel="noreferrer noopener" className="widget-link">
                  Ver puestos de trabajo
                </a>
              </li>
              <li>
                <p className='widget-link'>Envianos tu CV:  <a href="mailto:trabajo@equipomag.com" target="_blank" rel="noreferrer noopener" className="widget-link">
                  trabajo@equipomag.com
                </a>
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Credits */}
        <div className="row mt-4">
          <div className="col-12 text-center">
            <p className="mb-0">
              Coypyright © {new Date().getFullYear()} EquipoMAG. Todos los derechos reservados.
              <Link className='widget-info-text' target="_blank" rel="noreferrer noopener" to="https://www.sdsdeliver.io"> Made with ❤️ by SDS Deliver IO</Link>
            </p>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="menu-footer-menu">
          <ul className="footer-nav-menu">
            <li>
              <a href="/rsc">Responsabilidad Social Corporativa</a>
            </li>
            <li>
              <a href="/terminos">Términos y condiciones</a>
            </li>
            <li>
              <a href="/privacidad">Políticas de privacidad</a>
            </li>
            <li>
              <a href="/faq">Preguntas frequentes</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
